<template>
	<v-dialog v-model="dialog" max-width="600">
		<v-card>
			<v-card-title class="text-h5 grey lighten-2">
				{{ this.$t("generics.gameSettings") }}
			</v-card-title>
			<v-card-text>
				<game-form @save="onSave" />
			</v-card-text>

		</v-card>
	</v-dialog>
</template>

<script>
import GameForm from "./GameForm";
import {types} from "../../store/modules/Game.module";
export default {
	name: "GameEditDialog",
	components: {GameForm},
	props: {
		value: { type: Boolean },
	},
	methods:{
		onSave(game) {
			this.$store.commit(types.GET, game);
			this.$store.commit(types.SHOW_IN_TOOLBAR, true);
			this.$emit("close");
		}
	},
	computed:{
		dialog: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	}
};
</script>

<style scoped>

</style>
